const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Sudionicima se kešbek naknade uknjižavaju na temelju dostavljenih podataka o prihodima.",
};

export default {
  messages,
};
